import React from 'react';
import './index.scss';
// import LogoText from '../../LogoText';

export default function DialGauge({ style, speed = 0, time = 0.0, distance = 0 }) {
  const t = time.toFixed(1);
  const s = parseInt(speed);
  return (
    <div className="dial-gauge-root" {...style} >
      <div className="dial-gauge-inner">
        {/*<div className="dial-gauge-circle"></div>*/}
        <div className="icon-point" style={{
          'WebkitTransform': `rotate(${speed / (100 / (74 * 2)) - 74}deg)`,
          'transform': `rotate(${speed / (100 / (74 * 2)) - 74}deg)`,
        }} />
        <div className="dial-gauge-box">
          <div className="distance-box unit-box">
            <div className="unit-box-inner">
              { parseInt(distance) } <span className="unit">m</span>
            </div>  
          </div>
          <div className="velocity-box">
            <p className="v-text">{ s }</p>
            <p className="v-unit">km/h</p>
          </div>
          <div className="time-box unit-box">
            <div className="unit-box-inner">
              { t } <span className="unit">s</span>
            </div>  
          </div>
        </div>
      </div>
    </div>
  )
}